import {Link, LinkProps} from "react-router-dom";
import styles from "./BlockLink.module.scss"

export const BlockLink = (props:LinkProps)=> <Link {...props} className={styles.link} />